import baseURL from '@/config/index'
import { getToken,setToken } from '@/libs/util'
import axios from 'axios'

//基地址
let base = baseURL;
let instance = axios.create({
    responseType: 'blob', //返回数据的格式，可选值为arraybuffer,blob,document,json,text,stream，默认值为json
})
// instance 添加一个请求拦截器
instance.interceptors.request.use(function (config) {
    if(!config.url.includes('/create_token')){
        config.headers['Authorization'] = "Bearer "+getToken()
    }
    return config;
}, function (error) {
    // Do something with request error
    console.info("error: ");
    console.info(error);
    return Promise.reject(error);
})

// 导出
export const EXPORT = (url,method,params) => {
    return instance({
        method: method,
        url: `${base}` + url,
        params: params
    }).then(res => {
        return Promise.resolve(res.data)
    })
}


// WEBPACK FOOTER //
// ./src/libs/export.js